import {Component, OnInit, Input} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AppConfigService} from 'src/app-config.service';
import {GeneralService} from 'src/app/service/general-service';
import {NotificationService} from 'src/app/service/notification.service';
import {OrderService} from 'src/app/service/order-service';
import {ShareaService} from 'src/app/service/sharea.service';
import {Constant} from 'src/app/shared/constants/constant.class';
import {collapseTextChangeRangesAcrossMultipleVersions} from 'typescript';

@Component({
  selector: 'app-order-result-value',
  templateUrl: './order-result-value.component.html',
  styleUrls: ['./order-result-value.component.scss'],
  providers: [OrderService],
})
export class OrderResultValueComponent implements OnInit {
  orderItem: any = {
    patient: {},
  };

  groupResultValues = [];
  orderId: any;
  resultValues: any = {
    data: [
      {
        value: [
          {
            testedDate: '',
          },
        ],
      },
    ],
    specimenInfos: [
      {
        code: '',
        dateTaken: '',
      },
    ],
  };

  status: string = '';
  lstConfigPrintOrder = {
    address: '',
    backgroundLogo: '',
    ceo: '',
    conductor: '',
    doctor: '',
    logo: '',
    money: '',
    professionalCouncil: '',
    responsible: '',
    result: '',
  };
  lstPrintId: any;

  urlHeader = '';
  urlBackground = '';
  datas: any[] = [];
  cancelOrderTypeIds = [];

  constructor(
    private orderService: OrderService,
    private router: ActivatedRoute,
    private generalService: GeneralService,
    private configService: AppConfigService,
    private shareaService: ShareaService,
    private notificationService: NotificationService
  ) {
  }

  ngOnInit(): void {
    this.router.queryParams.subscribe((params) => {
      this.lstPrintId = params.id.split('_');
      this.cancelOrderTypeIds = params.orderTypeIds ? params.orderTypeIds.split(',').map(en => +en) : [];
      console.log(this.cancelOrderTypeIds);
      this.lstConfigPrintOrder = {
        address: JSON.parse(params.address),
        backgroundLogo: JSON.parse(params.backgroundLogo),
        ceo: JSON.parse(params.ceo),
        conductor: JSON.parse(params.conductor),
        doctor: JSON.parse(params.doctor),
        logo: JSON.parse(params.logo),
        money: JSON.parse(params.money),
        professionalCouncil: JSON.parse(params.professionalCouncil),
        responsible: JSON.parse(params.responsible),
        result: JSON.parse(params.result),
      };
    });
    this.getLstData();
    console.log(this.lstPrintId);
    console.log(this.lstConfigPrintOrder);
    console.log(this.datas);
  }

  getLstData() {
    for (let i = 0; i < this.lstPrintId.length; i++) {
      const get1 = new Promise((resolve, reject) => {
        this.orderService.getOrderResultValues(this.lstPrintId[i]).subscribe(
          (res) => {
            if (res !== null) {
              console.log(res);

              const resultValues = res;
              if (this.cancelOrderTypeIds.length){
                console.log('this.cancelOrderTypeIds', this.cancelOrderTypeIds);
                res.data = res.data.filter(en => !this.cancelOrderTypeIds.includes(en.value.orderTypeId));
                console.log(res.data);
              }
              const types = res.data.filter(en => en.type).map((en) => en.type.code);
              const distinctTypes = types.filter(
                (n, i) => types.indexOf(n) === i
              );
              const ret = [];
              distinctTypes.forEach((specimenTypeCode) => {
                console.log(specimenTypeCode, res.data);
                res.data
                  .filter((en) => en.type && en.type.code === specimenTypeCode)
                  .forEach((result) => {
                    let existsItem = ret.find(
                      (en) => en.code === specimenTypeCode
                    );
                    if (!existsItem) {
                      existsItem = {
                        code: specimenTypeCode,
                        name: result.type.name,
                        items: [],
                      };
                      ret.push(existsItem);
                    }
                    if (result) {
                      result.value.machineName = result.machineName;
                      existsItem.items.push(result.value);
                    }
                  });
              });
              const groupResultValues = ret;
              resolve({
                groupResultValues,
                resultValues
              });
            }
          },
          (error) => {
          }
        );
      });
      const get2 = new Promise((resolve, reject) => {
        this.orderService.getOrderById(this.lstPrintId[i]).subscribe(
          (res) => {
            const orderItem = res;
            const urlHeader =
              this.configService.getConfig().api.baseUrl +
              '/' +
              orderItem.partner?.headerLogo;
            const urlBackground =
              this.configService.getConfig().api.baseUrl +
              '/' +
              orderItem.partner?.backgroundLogo;
            resolve({
              orderItem,
              urlHeader,
              urlBackground
            });
          },
          (error) => {
          }
        );
      });
      Promise.all([get1, get2]).then((values: any) => {
        console.log(values);
        this.datas.push({
          groupResultValues: values[0].groupResultValues,
          resultValues: values[0].resultValues,
          orderDetail: values[1].orderItem,
          urlHeader: values[1].urlHeader,
          urlBackground: values[1].urlBackground,
          barcode: values[0].resultValues.specimenInfos[0]?.code,
        });
        console.log('datas', this.datas);
      });
    }
  }

  getGroupResultValue(data) {
    this.orderService.getOrderResultValues(data).subscribe(
      (res) => {
        if (res !== null) {
          console.log(res);
          this.resultValues = res;
          this.groupResultValues = res.data;
          console.log(this.groupResultValues);
        }
      },
      (error) => {
      }
    );
  }

  toTdCls(item: any) {
    if (item.resultType && item.resultType.unitType === 0) {
      const val = +item.valueStr;
      if (val < item.resultType.normalMin || val > item.resultType.normalMax) {
        return 'result-abnormal';
      }
      return 'result-normal';
    } else {
      return '';
    }
  }

  exportPdf() {
    const titlePrint = '';
    for (let i = 0; i < this.lstPrintId.length; i++) {
      const printContents = document.getElementById(`print-div-${this.lstPrintId[i]}`).innerHTML;
      const styleCommon = this.shareaService.getStyleCommonPrint();
      const content = `
      <html>
      <head>
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
      <title>${titlePrint}</title>
      <style>
        ${styleCommon}
        body {
          font-family: serif;
        }

        .logo-background {
          position: absolute;
          top: 0%;
          left: 0%;
          width: 100%;
          margin: auto;
          display: block;
          opacity: 0.1;
          margin-top: 260px;
        }

        .link-info {
          text-decoration: underline;
          color: #2e8acb;
        }

        .content-header {
          font-weight: 900;
          color: #2e8acb;
        }

        .logo {
          padding-left: 2rem;
        }

        .print-wrapper {
          width: 42%;
          margin: 16px auto;
          position: relative;
        }

        h1,
        p,
        div {
          margin: 0;
          padding: 0;
        }

        h1 {
          margin-bottom: 10px;
          text-transform: uppercase;
          font-size: 32px;
          font-weight: 900;
          color: #2e8acb;
        }

        h2 {
          font-weight: 900;
        }

        .row-info {
          display: flex;
          text-align: center;
          width: 90%;
          margin: 5px auto 0;
          span,
          p {
            flex: 2 1 auto;
          }
          padding-left: 50px;
        }


        .table-result {
          border: solid 1px rgb(0, 0, 0);
        }

        .table-result td,
        .table-result th:not(:last-child):after {
          padding: 3px 10px;
          border-right: solid 1px rgb(0, 0, 0);
          border-bottom: solid 1px rgb(0, 0, 0);
          color: #333;
          font-size: 16px;
          font-family: serif;
        }

        .table-result th {
          border-bottom: solid 1px rgb(0, 0, 0);
          text-align: center;
        }

        .result-abnormal td.color-change {
          color: red;
          font-weight: bold;
        }

        .info {
          font-family: serif;
        }

        .info td,
        th {
          font-size: 16px;
        }

        .info-contact p {
          text-align: center;
        }

        .sign {
          display: flex;
          text-transform: uppercase;
          justify-content: space-around;
          font-family: serif;
          font-weight: bold;
          margin-top: 1rem;
          height: 150px;
          font-size: 16px;
          margin-left: 3.2rem;
          margin-bottom: 1rem;
        }

        .sign > table > tr > td {
          font-weight: bold;
        }

        .content-footer:first-child {
          margin-bottom: 1rem;
        }
        .print-wrapper {
          width: 100%;
        }
      </style>
      </head>
      <body onload='window.print()'>${printContents}</body>
      </html>`;

      const payload = {
        html: content,
        orderId: parseInt(this.lstPrintId[i]),
        paperSize: 'A4',
      };
      this.generalService.exportPDF(payload).subscribe((res) => {
        if (res.isValid) {
          const link = document.createElement('a');
          // link.download = res.jsonData;
          link.setAttribute('download', res.jsonData);
          // link.href =
          //   this.configService.getConfig().api.baseUrl +
          //   "/api/Prescription/GetPdf/" +
          //   this.prescription.Id +
          //   "/" +
          //   res.jsonData;
          // if (!this.isMobile) {
          //   link.target = "_blank";
          // }
          link.click();
        }
      });
    }
  }
}
